import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="text-2xl font-bold font-heading text-primary-500">
              妖精动漫
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'text-primary-500'
                  : isScrolled
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-white hover:text-primary-300'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/all"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname.startsWith('/category')
                  ? 'text-primary-500'
                  : isScrolled
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-white hover:text-primary-300'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-500'
                  : isScrolled
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-white hover:text-primary-300'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-4">
            <div className={`relative ${isScrolled ? '' : 'text-white'}`}>
              <input
                type="text"
                placeholder="搜索漫画..."
                className={`pl-9 pr-4 py-2 rounded-full text-sm focus:outline-none transition-all w-48 focus:w-64 ${
                  isScrolled
                    ? 'bg-background-100 text-foreground-900 placeholder-foreground-400 border border-background-200'
                    : 'bg-white/20 text-white placeholder-white/60 border border-white/30'
                }`}
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm"></i>
            </div>
          </div>

          <button
            className="md:hidden flex items-center justify-center w-10 h-10 cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <i
              className={`text-xl ${
                isScrolled ? 'text-foreground-900' : 'text-white'
              } ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}
            ></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 space-y-3">
            <Link
              to="/"
              className={`block py-2 text-sm font-medium ${
                location.pathname === '/'
                  ? 'text-primary-500'
                  : 'text-foreground-700'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/all"
              className={`block py-2 text-sm font-medium ${
                location.pathname.startsWith('/category')
                  ? 'text-primary-500'
                  : 'text-foreground-700'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`block py-2 text-sm font-medium ${
                location.pathname === '/about'
                  ? 'text-primary-500'
                  : 'text-foreground-700'
              }`}
            >
              关于我们
            </Link>
            <div className="pt-2">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-full pl-9 pr-4 py-2 rounded-full text-sm bg-background-100 border border-background-200 text-foreground-900 placeholder-foreground-400 focus:outline-none"
              />
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}